import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { useEffect, useMemo, useRef, useState } from 'react';
import { hasTouchScreen } from '../helpers/accessibility';
import { getUADeviceType } from '../helpers/devices';
import { defineLocation } from '../helpers/locations';
export var useDeviceType = function useDeviceType() {
  var _useState = useState(defineLocation()),
      location = _useState[0],
      setLocation = _useState[1];

  var mounted = useRef(false);
  useEffect(function () {
    if (mounted.current) return;
    mounted.current = true;
    setLocation(defineLocation());
  });
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, getUADeviceType()), {}, {
      isBrowser: location.isBrowser,
      isServer: location.isServer,
      isNative: location.isNative,
      canUseWorkers: typeof Worker !== 'undefined',
      canUseEventListeners: location.isBrowser && !!window.addEventListener,
      canUseViewport: location.isBrowser && !!window.screen,
      hasTouchScreen: location.isBrowser && !!hasTouchScreen(),
      pixelRatio: location.isBrowser ? window.devicePixelRatio : 1
    });
  }, [location]);
};